import { useQuery } from "@apollo/client";
import { gql } from "@apollo/client";
import type {
  Organization,
  OrganizationMember,
  OrganizationInvite,
} from "@casey/db-types";

const GET_ORGANIZATION_MEMBERS_AND_INVITES = gql`
  query GetOrganizationMembersAndInvites($organizationSlug: String!) {
    organizationBySlug(slug: $organizationSlug) {
      id
      name
      slug
      description
      avatarUrl
      organizationMembers {
        nodes {
          organizationId
          userId
          role
          canWriteOrganization
          canWriteMembers
          canWriteProjects
          canWriteOfferings
          canWriteTemplates
          canWriteInvites
          canWriteSessions
          joinedAt
          invitedAt
          invitedByUserId
          createdAt
          profile {
            userId
            email
            firstName
            lastName
            avatarImageUrl
          }
        }
      }
      organizationInvites(condition: { archivedAt: null }) {
        nodes {
          id
          organizationId
          token
          role
          permissions
          expiresAt
          redeemedAt
          redeemedBy
          createdAt
          createdByUserId
          archivedAt
          archivedByUserId
        }
      }
    }
  }
`;

interface OrganizationMembersAndInvitesData {
  organizationBySlug: Organization & {
    organizationMembers: {
      nodes: OrganizationMember[];
    };
    organizationInvites: {
      nodes: OrganizationInvite[];
    };
  };
}

interface OrganizationMembersAndInvitesVariables {
  organizationSlug: string;
}

export function useOrganizationMembersAndInvites(organizationSlug: string) {
  return useQuery<
    OrganizationMembersAndInvitesData,
    OrganizationMembersAndInvitesVariables
  >(GET_ORGANIZATION_MEMBERS_AND_INVITES, {
    variables: { organizationSlug },
    errorPolicy: "all",
  });
}
